<script>
import Layout from '@layouts/main'
import AudioQuality from './audio-quality'
import ExternalPlayer from './external-player'
import AboutFooterMenu from './../../../partials/about-footer-menu'

export default {
    components: { Layout, AudioQuality, ExternalPlayer, AboutFooterMenu },
    props: {
        mainComponent: {
            type: String,
            default: 'AudioQuality',
        },
    },
    data() {
        return {
            user: {},
        }
    },
    page() {
        const title = 'Settings'
        const description = 'Settings'
        return {
            title,
            meta: [
                { name: 'title', vmid: 'title', content: title },
                { name: 'description', vmid: 'description', content: description },

                { property: 'og:title', vmid: 'og:title', content: title },
                { property: 'og:description', vmid: 'og:description', content: description },

                { property: 'twitter:title', vmid: 'twitter:title', content: title },
                { property: 'twitter:description', vmid: 'twitter:description', content: description },
            ],
        }
    },
    computed: {
        isPassSet() {
            return this.$store.state.member.passState === 'set'
        },
        isPremium() {
            return this.$store.getters['premium/isPremium']
        },
        tabs() {
            return [
                {
                    to: { name: 'settings/audio-quality' },
                    label: 'Audio Quality',
                },
                {
                    to: { name: 'settings/external-player' },
                    label: this.isPremium ? 'External Players' : 'External Players (Premium only)',
                },
            ]
        },
    },
}
</script>

<template>
    <Layout>
        <div class="settings-container">
            <BaseContent title="Settings">
                <BaseTabPanel
                    :tabs="tabs"
                    class="tabs"
                    is-underlined
                    is-unpadded
                    address-navigation
                />
                <component :is="mainComponent" />
            </BaseContent>
            <BaseSection
                padded
                class="settings-footer"
            >
                <div class="separator" />
                <AboutFooterMenu/>
            </BaseSection>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.settings-container {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - $size-music-player - $size-menu-bar-height);
    padding-bottom: $s-xxl;
}

.tabs {
    margin-bottom: $s-xxl;
}

.settings-footer {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    padding-top: $s-xxl;
    padding-bottom: $s-xxl;
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    padding: $s-s 0;
    border-top: 1px solid $c-dusty-gray;
    opacity: 0.1;
}

@include desktop {
    .settings-container {
        min-height: calc(100vh - $size-music-player - $s-xl);
        padding-bottom: 0;
    }
}
</style>
